<template>
  <div>
    <b-tooltip target="payout-info">{{$t('payoutInfo')}}</b-tooltip>
    <b-card 
      class="card-container"
      body-class="border-card-info"
      header-class="border-header"
     >
    <template #header>
        <span>{{$t('titlePayout')}} <b-icon icon="question-circle" id="payout-info"></b-icon></span> 
    </template>
    <div class="mt-2">
        <div class="card-subtitle-preference">
          <span class="w-100 subtitle-current-email">
            {{ $t('currentPaypalEmail') }}
            <b-badge pill v-if="loaded" :class="profile.paypal_info && profile.paypal_info.email_paypal ? 'verified-email' : 'not-verified-email'"> 
              {{ profile.paypal_info && profile.paypal_info.email_paypal ? $t("creator.verified"): $t("creator.notVerified")}}
            </b-badge> 
            <b-skeleton class="skeleton-badge-settings-email" type="badge" v-else></b-skeleton>

          </span>
          <div class="d-flex align-items-center">
            <span :class="{'mr-05': profile.paypal_info && profile.paypal_info.email_paypal !== ''}" v-if="loaded">{{ profile.paypal_info && profile.paypal_info.email_paypal !== '' ? profile.paypal_info.email_paypal : ''}}</span>
            <b-skeleton class="col-1 m-0 mr-1" v-else></b-skeleton>
            <b-link class="link-update-paypal-info avenir-medium" @click="openSider(false)">{{profile.paypal_info && profile.paypal_info.email_paypal  !== '' ? $t('updateEmailPaypal') : $t('addPaypalEmail')}}</b-link>
            <b-link
              v-if="loaded && profile.paypal_info && profile.paypal_info.email_paypal"
              class="link-delete-paypal-info avenir-medium ml-1"
              @click="openModalConfirmationDelete(false)"
            >
              {{ $t('delete') }}
            </b-link>
          </div>
        </div>
    </div>

  </b-card>  

  <b-tooltip target="payoneer">{{$t('payoneerInfo')}}</b-tooltip>
    <b-card 
      class="card-container"
      body-class="border-card-info"
      header-class="border-header"
     >
    <template #header>
        <span>{{$t('payoneerPayout')}} <b-icon icon="question-circle" id="payoneer"></b-icon></span> 
    </template>
    <div class="mt-2">
        <div class="card-subtitle-preference">
          <span class="w-100 subtitle-current-email">
            {{ $t('currentPayoneerEmail') }}
            <b-badge v-if="loaded" pill :class="profile.paypal_info && profile.paypal_info.email_payoneer ? 'verified-email' : 'not-verified-email'"> {{ profile.paypal_info && profile.paypal_info.email_payoneer ? $t("creator.verified"): $t("creator.notVerified")}}</b-badge> 
            <b-skeleton class="skeleton-badge-settings-email" type="badge" v-else></b-skeleton>
          </span>
          <div class="d-flex align-items-center">
            <span :class="{'mr-05': profile.paypal_info && profile.paypal_info.email_payoneer !== ''}" v-if="loaded">{{ profile.paypal_info && profile.paypal_info.email_payoneer !== '' ? profile.paypal_info.email_payoneer : '' }} </span>
            <b-skeleton class="col-1 m-0 mr-1" v-else></b-skeleton>
            <b-link class="link-update-paypal-info avenir-medium" @click="openSider(true)">{{profile.paypal_info && profile.paypal_info.email_payoneer  !== '' ? $t('updateEmailPayoneer') : $t('addPayoneerEmail')}}</b-link> 
            <b-link
              v-if="loaded && profile.paypal_info && profile.paypal_info.email_payoneer"
              class="link-delete-paypal-info avenir-medium ml-1"
              @click="openModalConfirmationDelete(true)"
            >
              {{ $t('delete') }}
            </b-link>
          </div>
        </div>
    </div>

  </b-card>

  <b-card>
    <validation-observer #default="{invalid}">
      <b-form>
        <b-row>
          <b-col sm="6">
            <b-form-group
              label-for="is_national"
              class="avenir-medium f-12"
              :description="$t('accountMx')"
            >
              <b-form-checkbox id="is_nacional" v-model="is_national">{{$t('accountNational')}}</b-form-checkbox>
            </b-form-group>
          </b-col>

          <b-col sm="6">
            <b-form-group
              :label="$t('nameBeneficiary')"
              label-for="beneficiary_name"
            >
              <validation-provider 
                #default="{ errors }"
                :name="$t('nameBeneficiary')"
                :vid="$t('nameBeneficiary')"
                rules="required">
                <b-form-input 
                  id="beneficiary_name" 
                  v-model="beneficiary_name"
                  :placeholder="$t('nameBeneficiary')" 
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col sm="6">
            <b-form-group
              :label="$t('lastNameBeneficiary')"
              label-for="beneficiary_last_name"
            >
              <validation-provider  
                #default="{ errors }"
                :name="$t('lastNameBeneficiary')"
                :vid="$t('lastNameBeneficiary')"
                rules="required">
                <b-form-input 
                  id="beneficiary_last_name" 
                  v-model="beneficiary_last_name"
                  :placeholder="$t('lastNameBeneficiary')" 
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col sm="6">
            <b-form-group
              :label="$t('bank')"
              label-for="bank"
            >
              <validation-provider  
                #default="{ errors }"
                :name="$t('bank')"
                :vid="$t('bank')"
                rules="required">
                <b-form-input 
                  id="bank" 
                  v-model="bank" 
                  :placeholder="$t('bank')" 
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col sm="6">
            <b-form-group
              :label="getLabelClabe()"
              label-for="clabe"
            >
              <validation-provider 
                #default="{ errors }"
                :name="is_national ? 'CLABE' : 'ABBA / SWIFT / BIC'"
                :vid="is_national ? 'CLABE' : 'ABBA / SWIFT / BIC'"
                rules="required">
                <b-form-input 
                  id="clabe" 
                  v-model="clabe" 
                  :placeholder="is_national ? 'CLABE' : 'ABBA / SWIFT / BIC'" 
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col sm="6">
            <b-form-group
              :label="$t('account')"
              label-for="account"
            >
              <validation-provider  
                #default="{ errors }"
                :name="$t('account')"
                :vid="$t('account')"
                rules="required">
                <b-form-input 
                  id="account" 
                  v-model="account" 
                  :placeholder="$t('account')" 
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col sm="6">
            <b-form-group
              :label="$t('email')"
              label-for="email"
            >
              <validation-provider rules="required|email" name="email" #default="{ errors }">
                <b-form-input id="email" v-model="email_value"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col sm="6">
            <b-form-group :label="$t('telephone')" class="avenir-medium f-12">
              <validation-provider
                name="Celular"
              >
                <input-tel-brandme
                  :country_dad="country"
                  :number_dad="telephone"
                  @number="updateTelephone"
                ></input-tel-brandme>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col sm="6">
            <b-form-group
              v-if="!is_national"
              :label="$t('city')"
              label-for="city"
            >
              <validation-provider 
                #default="{ errors }"
                :name="$t('city')"
                :vid="$t('city')"
                rules="required">
                <b-form-input 
                  id="city" 
                  v-model="city"
                  :placeholder="$t('city')" 
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col sm="6">
            <b-form-group
              v-if="!is_national"
              :label="$t('diecctionInternational')"
              label-for="address"
            >
              <validation-provider  
                #default="{ errors }"
                :name="$t('address')"
                :vid="$t('address')"
                rules="required">

                <b-form-input 
                  id="address" 
                  v-model="address"  
                  :placeholder="$t('address')" 
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <div class="mt-1 text-center">
        <b-button
          variant="blue-button"
          class="blue-button"
          :disabled="invalid || !state_telephone"
          @click="updatePyamentData()"
        >
          {{$t('dashboard.save')}}
        </b-button>
      </div>
      </b-form>
    </validation-observer>
      <sider-paypal
        class="open-sidebar-search"
        :payoneer="sider_payoneer"
        @close_siderbar_paypal="closeSider"
        @update_payment_data="updateProfile"
        @open_confirm="confirm_payment_data = true"
        :show_sider_paypal="show_sider_paypal"
        :profile="profile"
        ref="sidebar_paypal_form"
        v-if="show_sider_paypal"
      />
    </b-card>

    <b-modal v-model="confirm_payment_data" hide-footer centered @change="is_form_down = false">
      <p>{{ $t('checkAccount1') }}.</p>
      <p>{{ $t('checkAccount2') }}.</p>

      <div class="d-flex flex-wrap justify-content-end">
        <b-button variant="outline-danger" class="mr-1" @click="confirm_payment_data = false; is_form_down = false">{{$t('tracking.cancel')}}</b-button>
        <b-button class="blue-button" variant="blue-button" @click="confirmModal">{{$t('confirmAccept')}}</b-button>
      </div>
    </b-modal>

    <modal-brandme
      :key="change_modal_delete_email"
      :show_modal="show_modal_delete_email"
      @hidden="show_modal_delete_email = false"
      v-if="show_modal_delete_email"
    >
      <template #title>
        <div class="w-100 text-center">
          <h4 class="mb-0 font-weight-bold">
            {{ delete_payoneer ? $t('deletePayoneerEmail') : $t('deletePaypalEmail') }}
          </h4>
        </div>
      </template>

      <template #body>
        <div class="px-1">
          <p class="text-center mb-2 font-weight-medium">
            {{ delete_payoneer ? $t('sureDeletePayoneerEmail') : $t('sureDeletePaypalEmail') }}
          </p>

          <div class="paypal-delete-card text-center">
            <h6 class="mb-0 font-weight-bold text-overflow">
              {{ delete_payoneer ? profile.paypal_info.email_payoneer : profile.paypal_info.email_paypal }}
            </h6>
          </div>

          <p class="text-danger small text-center mt-1 mb-0">
            {{ $t('deletePaypalEmailConfirmation') }}
          </p>
        </div>
      </template>

      <template #footer>
        <div class="d-flex justify-content-between w-100">
          <b-button
            variant="outline-secondary"
            class="w-50 mr-1"
            @click="closeModalConfirmationDelete"
          >
            {{ $t('creator.cancel') }}
          </b-button>
          <b-button
            variant="danger"
            class="w-50 ml-1"
            :disabled="deleting_email"
            @click="confirmDeleteEmail"
          >
            {{ $t('delete') }}
          </b-button>
        </div>
      </template>
    </modal-brandme>
  </div>
</template>

<script>
import {
  BCard, BForm, BRow, BCol, BFormGroup, BFormCheckbox, BButton, BFormInput, BBadge, BTooltip, BLink, BSkeleton, BModal,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import { getUserData, updatePaymentData } from '@/libs/utils/user';
import profile_service from "@/services/profile";
import { removePaypal, removePayoneer } from "@/services/finance";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import SiderPaypal from '@/views/pages/proposals/stepper/siderPaypal.vue';
import InputTelBrandme from '@/views/components/inputs/InputTelBrandme.vue';

export default {
  name: "AccountSettingPaymentData",
  components: {
    SiderPaypal,
    ModalBrandme: () => import('@/views/components/modal/ModalBrandme.vue'),
    BModal,
    BTooltip,
    BSkeleton,
    BBadge,
    BCard,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    BButton,
    BFormInput,
    BLink,
    ValidationProvider,
    ValidationObserver,
    InputTelBrandme,
  },
  props: {
    profile: {
      type: Object
    },
    loaded: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      updatePaymentData,
      getUserData,
      sider_payoneer: false,
      show_sider_paypal: false,
      required,
      email,
      is_national: false,
      beneficiary_name: '',
      beneficiary_last_name: '',
      bank: '',
      clabe: '',
      account: '',
      email_value: '',
      telephone: '',
      country: 'MX',
      city: '',
      address: '',
      is_verified: '',
      state_telephone: false,
      confirm_payment_data: false,
      is_form_down: false,
      show_modal_delete_email: false,
      change_modal_delete_email: 0,
      deleting_email: false,
      delete_payoneer: false,
    };
  },
  created() {
    const user = getUserData()
    if (user.has_payment_data) {
      this.is_national = user.payment_data.is_national
      this.beneficiary_name = user.payment_data.beneficiary_name
      this.beneficiary_last_name = user.payment_data.beneficiary_last_name
      this.bank = user.payment_data.bank
      this.clabe = user.payment_data.clabe
      this.account = user.payment_data.account
      this.email_value = user.payment_data.email
      this.telephone = user.payment_data.telephone
      this.country = user.payment_data.country || 'MX'
      this.city = user.payment_data.city
      this.address = user.payment_data.address
      this.is_verified = user.is_verified
    }
  },
  methods: {
    confirmModal() {
      this.confirm_payment_data = false; 
      if (!this.is_form_down) this.$refs['sidebar_paypal_form'].serviceSaveEmail();
      else this.updatePyamentData(false)
    },
    openSider(sider_payoneer) {
      this.sider_payoneer = sider_payoneer;
      this.show_sider_paypal = true;
    },
    updateTelephone(telephone_data) {
      this.telephone = telephone_data.number;
      this.state_telephone = telephone_data.state;
      this.country = telephone_data.country;
    },
    updateProfile(response) {
      this.$emit("update_payment_data", response);
    },
    closeSider() {
      this.show_sider_paypal = false
    },
    openModalConfirmationDelete(delete_payoneer) {
      this.delete_payoneer = delete_payoneer
      this.show_modal_delete_email = true
      this.change_modal_delete_email += 1
    },
    closeModalConfirmationDelete() {
      this.show_modal_delete_email = false
      this.change_modal_delete_email += 1
    },
    async confirmDeleteEmail() {
      if (this.deleting_email) return
      this.deleting_email = true
      await this.deleteEmail()
      this.deleting_email = false
      this.closeModalConfirmationDelete()
    },
    async deleteEmail() {
      const response = this.delete_payoneer ? await removePayoneer() : await removePaypal()
      if (!response || response.status >= 400) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: this.$t('err'),
            text: this.$t('messageAccountSettingError'),
            icon: "CoffeeIcon",
            variant: "danger",
          },
        });
        return
      }
      const email_key = this.delete_payoneer ? 'email_payoneer' : 'email_paypal'
      this.$emit("update_payment_data", { ...this.profile.paypal_info, [email_key]: '', payment_data: this.profile.payment_data });
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: this.delete_payoneer ? this.$t('payoneerEmailDeleted') : this.$t('paypalEmailDeleted'),
          variant: 'success',
          icon: 'CheckCircleIcon',
          text: ''
        }
      })
    },
    getLabelClabe() {
      return this.is_national ? 'CLABE' : 'ABBA / SWIFT / BIC'
    },
    updatePyamentData(condition = true) {
      if (!this.profile.payment_data?.was_accepted && condition) {
        this.confirm_payment_data = true;
        this.is_form_down = true;
        return;
      }
      const form_data = {
        is_national: this.is_national,
        beneficiary_name: this.beneficiary_name,
        beneficiary_last_name: this.beneficiary_last_name,
        bank: this.bank,
        clabe: this.clabe,
        account: this.account,
        email: this.email_value,
        telephone: this.telephone,
        country: this.country,
        username: this.$route.params.username,
        network: this.$route.params.network,
      };

      if (!this.is_national) {
        form_data.city = this.city;
        form_data.address = this.address;
      }

      profile_service.updatePaymentData(form_data)
        .then(response => {
          this.$emit("update_payment_data", response, true);
          if (response.status) {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title:  this.$t('err'),
                text: this.$t('messageAccountSettingError'),
                icon: "CoffeeIcon",
                variant: "danger",
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: this.$t('dashboard.saved'),
                variant: 'success',
                icon: 'CheckCircleIcon',
                text: ''
              }
            })
            updatePaymentData(response)
          }
        })
    }
  },
  watch: {
    is_national() {
      this.address = '',
      this.city = ''
    }
  }
};
</script>
<style scoped>
.skeleton-badge-settings-email {
  width: 100px;
  height: 20px;
  border-radius: 30px;
  margin-left: 1em;
}
.mr-05 {
  margin-right: 0.5em;
}
.subtitle-current-email {
  font-size: 12px;
  font-family: 'avenir-medium';
  display: flex;
}
.link-update-paypal-info {
  color: #0096fe;
}
.link-delete-paypal-info {
  color: #ea5455;
}
.paypal-delete-card {
  border: 1px solid #e0e0e0;
  border-radius: 0.75rem;
  padding: 1rem;
  background: #f9fafb;
}
.f-12 {
  font-size: 12px;
}
</style>
<style>
.card-container {
  border-radius: 0.75rem !important;
}
.border-card-info {
  border: 0.0625rem solid rgba(222,226,230,.7);
  border-top: none;
  border-radius: 0rem 0rem 0.75rem 0.75rem;
}
.border-header {
  border: 0.0625rem solid rgba(222,226,230,.7) !important;
  border-radius: 0.75rem 0.75rem 0rem 0rem !important;
}
.verified-email {
  background: #2f9d76;
  margin-left: 3px;
  font-size: 9.5px;
}
.not-verified-email {
  background: #b41212;
  margin-left: 3px;
  font-size: 9.5px;
}
</style>